(function($){

	/**
	 * Los vínculos con clase disabled no hacen nada al ser clicados
	 */
	$('.bar-btn--disabled').on('click',function(e){
		e.preventDefault();
	});


	/**
	 * Los vínculos de la paginación con clase disabled no hacen nada al ser clicados
	 */
	$('.bar-pagination__link--disabled').on('click',function(e){
		e.preventDefault();
	});


})(jQuery)